import React, {useState, useEffect} from "react";

// Importing images
import logo from "../assets/img/logo.webp";
import BoucMediaWhite from "../assets/img/BoucMedia_White_3_1296x.webp";
import tvIcon from "../assets/icon/tv.webp";
import phoneIcon from "../assets/icon/phone.webp";
import boxIcon from "../assets/icon/box.webp";
import roIcon from "../assets/icon/rock.webp";
import womenImage from "../assets/img/women.webp";
import mainFon from "../assets/img/mainFon.webp";
import Label from "./Label";

function ExampleReactComponent() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [services, setServices] = useState([]); // Состояние для данных услуг
    const [loading, setLoading] = useState(true); // Состояние загрузки
    const [error, setError] = useState(null); // Состояние для ошибок

    // Хук для загрузки данных из API
    useEffect(() => {
        fetch("/wp-json/wp/v2/posts?categories=2") // Замените '2' на ID вашей категории services
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch services.");
                }
                return response.json();
            })
            .then((data) => {
                console.log(data);
                const formattedServices = data.map((post) => ({
                    id: post.id,
                    title: post.title.rendered,
                    content: post.content.rendered,
                    price: post?.meta?.service_price,
                    img: post.featured_media_url || tvIcon, // Добавьте изображение, если доступно, или иконку по умолчанию
                }));
                setServices(formattedServices);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching services:", error);
                setError(error.message);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <p>Loading services...</p>;
    }

    if (error) {
        return <p>Error: {error}</p>;
    }

    return (
        <Label>

            <section className="our-services">
                <div className="container">
                    <div className="our-services-box">
                        <div className="our-services-head">
                            <h1 style={{fontSize: "4rem"}}>Services</h1>
                        </div>
                        <div className="our-services-body our-services-body-mini" style={{marginTop: "4rem"}}>
                            {services.map((service) => {
                                return (
                                    <a href={`/services/${service.id}`} className="our-services-item" key={service.id}>
                                        <img src={service.img} alt={service.title}/>
                                        <p className="card__price">Bouc</p>
                                        <h4 className="card__name"
                                            dangerouslySetInnerHTML={{__html: service.title}}></h4>
                                        {service.price && (
                                            <p className="card__price">
                                                ${parseInt(service.price).toLocaleString('en-US')}
                                            </p>
                                        )}
                                    </a>
                                )
                            })}
                        </div>

                    </div>
                </div>
            </section>

        </Label>
    );
}

export default ExampleReactComponent;
